import { Point } from "../../Utils/Point";
import { AbstractBgTileModel } from "./TileModels/AbstractBgTileModel";

export abstract class AbstractBgTileContainerModel<T extends AbstractBgTileModel>{
    public tiles: T[] = [];
    public speed: number = 100;

    protected abstract _createTile(): T;

    protected _createTiles(amount: number) {
        for (let i = 0; i < amount; i++) {
            const tile = this._createTile();
            tile.pos.set(i * tile.width, tile.pos.y);
            this.tiles.push(tile);
        }
    }


}